<template>
  <div id="mysingletrailsapp">
    <CustomerSubscription />
  </div>
</template>

<script>
import CustomerSubscription from './components/CustomerSubscription.vue';

export default {
  name: 'MySingletrailsApp',
  components: {
    CustomerSubscription,
  },
};
</script>

<style scoped>
.mrbox.nofill {
  padding: 0;
}
</style>
